<template>
  <div class="beast-mask" v-show="isShow" :style="maskStyles" :class="mclass" @click="maskTap"></div>
</template>

<script>
  import utils from './utils'

  const DEFAULT_STYLES = {
    height : '100%',
    width : '100%',
    position : 'fixed',
    zIndex : 1000,
    top : 0,
    left : 0,
    opacity : 0.4,
    background : '#000000'
  }

  const handler = (e) => {
    e.preventDefault()
    // e.stopPropagation()
  }

  export default {
    name: 'mask',
    props: {
      mshow: Boolean,
      mopacity: Number,
      zIndex: Number,
      mbackground: String,
      mclass: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        maskStyles: '',
        isShow: false
      }
    },
    created(){
      this.showChange()
    },
    watch: {
      'zIndex': function (val) {
        this.showChange()
      },
      'mshow': function (val) {
        // if(!val) {
        //   return
        // }
        this.showChange()
      }
    },
    methods: {
      maskTap () {
        this.$emit('maskTap')
      },
      showChange() {
        // if(this.mshow){
        //   this.$el && this.$el.addEventListener('touchmove', handler, false)
        // }else{
        //   this.$el && this.$el.removeEventListener('touchmove', handler, false)
        // }
        this.mbackground !== undefined && (DEFAULT_STYLES.background= this.mbackground)
        this.zIndex !== undefined && (DEFAULT_STYLES.zIndex = this.zIndex)
        this.mopacity !== undefined && (DEFAULT_STYLES.opacity = this.mopacity)
        this.maskStyles = utils.setStyle(DEFAULT_STYLES).join(';')
        this.isShow = this.mshow
      }
    }
  }
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// index.vue?2a138d10